import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "./../store";
import FilterView, { components } from "./filter";
import { Case, Notification } from "src/api/classes";
import AsyncSelect from "react-select/lib/Async";
import { emphasize } from "@material-ui/core/styles/colorManipulator";
import {
  createStyles,
  withStyles,
  IconButton,
  Badge,
  Avatar,
  Tooltip
} from "@material-ui/core";
import { withRouter, RouteComponentProps } from "react-router";
import NotificationIcon from "@material-ui/icons/Notifications";
import { Link } from "react-router-dom";
import { getUserPicture, DEFAULT_AVATAR, getUserID } from "src/auth/auth";
import { PATH_PROFILE } from "src/routes";
import * as actions from "../store/cases/actions";

interface Props extends RouteComponentProps<any> {
  cases: Case[];
  notifications: Notification[];
  theme: any;
  classes: any;
  fetchNotifications: () => void;
}
interface State {}
class SearchBar extends React.Component<Props, State> {
  select = undefined;
  state = {
    suggestions: [],
    filteredSuggestions: [],
    caseName: [],
    value: undefined
  };
  componentWillMount() {
    this.prepareCases(this.props.cases);
    if (!this.props.notifications) {
      this.props.fetchNotifications();
    }
    if (window.localStorage.getItem("notificationDisabled") === "true") {
      setInterval(() => {
        this.props.fetchNotifications();
      }, 60000);
    }
  }
  componentWillReceiveProps(next) {
    this.prepareCases(next.cases);
  }
  prepareCases = (cases: Case[]) => {
    //console.log(cases);
    if (cases) {
      const suggestions = cases.map(i => ({
        label: i.title,
        value: i.id
      }));
      //console.log("suggestions", suggestions);

      this.setState({
        suggestions: suggestions,
        filteredSuggestions: suggestions.reverse().slice(0, 10)
      });
    }
  };
  filterSuggestions = text => {
    if (!text) {
      return;
    }
    const counter = 0;
    const value = text.toLowercase();
    const suggestions = this.state.suggestions.filter(i => {
      return i.label.toLowercase().contains(value);
    });
    this.setState({
      filteredSuggestions: suggestions.slice(0, Math.min(counter, 10))
    });
  };
  handleInputChange = e => {
    //console.log(e, a);
    if (e && e.value) {
      this.props.history.push("/case/" + e.value);
      console.warn(this.select.select.select);
      //this.select.select.select.setValue("", "clear");
      if (this.select && this.select.select && this.select.select.select) {
        setTimeout(() => {
          this.select.select.select.clearValue();
        }, 1);
      }
    }
  };
  render() {
    const filterCases = (inputValue: string) => {
      if (inputValue) {
        return this.state.suggestions
          .filter(i => i.label.toLowerCase().includes(inputValue.toLowerCase()))
          .slice(0, 10);
      }
      return this.state.suggestions.slice(0, 10);
    };

    const loadOptions = (inputValue, callback) => {
      setTimeout(() => {
        callback(filterCases(inputValue));
      }, 1);
    };
    const notifications =
      this.props.notifications &&
      this.props.notifications.filter(i => i.read === 0);
    return (
      <div
        style={{
          width: "100%",
          zIndex: 1300,
          display: "flex",
          flexDirection: "row"
        }}
      >
        <div
          style={{
            margin: 16,
            left: 0,
            flex: 1
          }}
        >
          <AsyncSelect
            ref={r => {
              if (r && r !== null) {
                this.select = r;
              }
            }}
            classes={this.props.classes}
            components={components}
            loadOptions={loadOptions}
            onChange={this.handleInputChange}
            defaultOptions={this.state.filteredSuggestions}
            placeholder={"Search Case"}
            isClearable
          />
        </div>
        <Link to="/notifications">
          <Tooltip title="Notifications">
            <IconButton style={{ right: 8, top: 8 }}>
              {notifications && notifications.length > 0 ? (
                <Badge color="error" badgeContent={notifications.length}>
                  <NotificationIcon />
                </Badge>
              ) : (
                <NotificationIcon />
              )}
            </IconButton>
          </Tooltip>
        </Link>
        <Link to={"/profile/" + getUserID()}>
          <IconButton
            style={{
              marginTop: 8,
              marginRight: 8,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Avatar
              alt="Remy Sharp"
              style={{
                alignSelf: "center",
                width: 32,
                height: 32
              }}
              src={getUserPicture()}
              onError={(e: any) => {
                e.target.onerror = null;
                e.target.src = DEFAULT_AVATAR;
              }}
            />
          </IconButton>
        </Link>
      </div>
    );
  }
}
const styles = theme =>
  createStyles({
    root: {
      flexGrow: 1,
      "& div": {
        zIndex: 1,
        position: "absolute"
      }
    },
    input: {
      display: "flex",
      padding: 0
    },
    valueContainer: {
      display: "flex",
      flexWrap: "wrap",
      flex: 1,
      alignItems: "center"
    },
    chip: {
      margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`
    },
    chipFocused: {
      backgroundColor: emphasize(
        theme.palette.type === "light"
          ? theme.palette.grey[300]
          : theme.palette.grey[700],
        0.08
      )
    },
    noOptionsMessage: {
      padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
    },
    singleValue: {
      fontSize: 16
    },
    placeholder: {
      position: "absolute",
      left: 2,
      fontSize: 16
    },
    paper: {
      marginTop: theme.spacing.unit
    },
    divider: {
      height: theme.spacing.unit * 2
    }
  });
function mapStateToProps(state: GlobalState, own: Props) {
  return {
    cases: state.cases.list,
    notifications: state.cases.notifications
  };
}
function mapDispatchToProps(dispatch) {
  return {
    fetchNotifications: (): any => dispatch(actions.fetchNotifications())
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(SearchBar)));



// WEBPACK FOOTER //
// ./src/components/searchBar.tsx